import React, { useState, useEffect, useCallback } from "react";
import Table from "react-bootstrap/Table";
import PropTypes from "prop-types";
import { numberFormat } from "../../common/helper";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { HotKeys } from "react-hotkeys";
// import * as BSIcons from "react-icons/bs";
import * as FAIcons from "react-icons/fa";
import * as AIIcons from "react-icons/ai";
import * as BIIcons from "react-icons/bi";
import Search from "../search/search";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  clientSearch as clientSearchApi,
  createClient,
  emptyClient,
} from "../../api/clients.api";
import { getJVPartners } from "../../lookups";
import NoteModal from "../notes/notes";
import {
  createEntityBeneficiary,
  updateEntityBeneficiary as updateEntityBeneficiaryApi,
} from "../../api/beneficiaries.api";
import TableHeaderSort from "../table-header-sort/table-header-sort";
import ClientForm from "./client-form/client-form";
import ClientView from "./client-view/client-view";
import EntityBeneficiaryView from "./entity-benficiary-view/entity-beneficiary-view";
import EntityBeneficiaryForm from "./entity-beneficiary-form/entity-benficiary-form";
import Pagination from "../pagination/pagination";
// import BeneficiaryForm from "./beneficiary-form/beneficiary-form";
// import CurrentTrades from "./current-trades/current-trades";
// import CurrentTradesReport from "./current-trade-report/current-trade-report";
// import CurrentMarketOrders from "./current-market-orders/current-market-orders";

import "./client-table.css";
import "../table/generic-table.css";
import Loader from "../loader/loader";
import FormLoader from "../form-loader/form-loader";
import { RequestResponseModal } from "../form-cofirmation-modal/form-confirmation-modal";
import EntityBeneficiaryEditForm from "./entity-beneficiary-edit-form/entity-beneficiary-edit-form";

const searchOptions = [
  { name: "First Name", value: "firstname" },
  { name: "Last Name", value: "surname" },
];

const keyMap = {
  PREVIEW: "shift+r",
};

const ClientTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showNote, setShowNote] = useState(false);

  const [showLoader, setShowLoader] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const [allocatedClient, setAllocatedClient] = useState(emptyClient);
  const [allocatedBeneficiary, setAllocatedBeneficiary] = useState({});
  const [allocatedClientId, setAllocatedClientId] = useState(null);

  const [addClient, setAddClient] = useState(false);
  const [viewClient, setViewClient] = useState(false);
  const [addBeneficiary, setAddBeneficiary] = useState(false);
  const [editBeneficiary, setEditBeneficiary] = useState(false);
  const [viewBeneficiary, setViewBeneficiary] = useState(false);

  const [clientFormType, setClientFormType] = useState("");

  const [searchText, setSearchText] = useState("");
  const [searchFilter, setSearchFilter] = useState(searchOptions[0].value);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortArray, setSortArray] = useState([]);
  const [upperThreshold, setUpperThreshold] = useState(undefined);
  const [lowerThreshold, setLowerThreshold] = useState(undefined);
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const doClientSearch = useCallback(async () => {
    setIsLoading(true);
    const result = await clientSearchApi(
      searchFilter,
      searchText,
      page,
      rowsPerPage,
      sortArray,
    );
    if (result) {
      setData(result.data?.results);
      setPageCount(result.data?.total_pages);
      setUpperThreshold(result.data?.position?.first);
      setLowerThreshold(result.data?.position?.last);
    }
    setIsLoading(false);
  }, [searchFilter, searchText, page, rowsPerPage, sortArray]);

  useEffect(() => {
    doClientSearch();
  }, [doClientSearch]);

  // UseEffect to fetch lookups
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/lookups/country/`, {
              headers: {
                Authorization: `JWT ${sessionStorage.getItem("access")}`,
              },
            });
            if (res.data?.results) {
              setCountries(res.data.results);
            } else if (Array.isArray(res.data)) {
              setCountries(res.data);
            }
      } catch(err){
        console.log("Error fetching countries: ", err);
      }
    }

    const fetchCurrencies = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/lookups/currencies/`, {
              headers: {
                Authorization: `JWT ${sessionStorage.getItem("access")}`,
              },
            });
            if (res.data?.results) {
              setCurrencies(res.data.results);
            } else if (Array.isArray(res.data)) {
              setCurrencies(res.data);
            }
      } catch(err){
        console.log("Error fetching currencies: ", err);
      }
    }

    fetchCountries();
    fetchCurrencies();
  }, [])

  const createBeneficiary = async (beneficiary) => {
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/broker-portal/beneficiaries/?id=${allocatedClient.entity_id}`,
      beneficiary,
      {
        headers: {
          Authorization: `JWT ${sessionStorage.getItem("access")}`,
        },
      }
    );
    return res;
  }

  const updateBeneficiary = async (beneficiary) => {
    const res = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/broker-portal/beneficiaries/${beneficiary.id}/`,
      beneficiary,
      {
        headers: {
          Authorization: `JWT ${sessionStorage.getItem("access")}`,
        },
      }
    );
    return res;
  }

  const clientSort = (newSortArray) => {
    setSortArray(newSortArray);
  };

  const showAddClient = () => {
    setAllocatedClient(emptyClient);
    setAddClient(true);
    setViewClient(false);
  };

  const closeAddClient = () => {
    setAddClient(false);
  };

  const showViewClient = (client, type) => {
    setAllocatedClient(client);
    setViewClient(true);
    setAddClient(false);
    setClientFormType(type);
  };

  const closeViewClient = () => {
    setViewClient(false);
    setAllocatedClient(emptyClient);
  };

  const showEditBeneficiary = (ben) => {
    setAllocatedBeneficiary(ben);
    setViewBeneficiary(false);
    setEditBeneficiary(true);
  };

  const closeEditBeneficiary = () => {
    setAllocatedBeneficiary({});
    setEditBeneficiary(false);
  };

  const backFromEditBeneficiary = () => {
    setEditBeneficiary(false);
    setViewBeneficiary(true);
  };

  const showAddBeneficiary = () => {
    setAddBeneficiary(true);
  };

  const closeAddBeneficiary = () => {
    setAddBeneficiary(false);
    setAllocatedClient(emptyClient);
  };

  const backFromAddBeneficiary = () => {
    setAddBeneficiary(false);
    setViewBeneficiary(true);
  };

  const showViewBeneficiary = (client) => {
    if (client) setAllocatedClient(client);
    setViewBeneficiary(true);
  };

  const closeViewBeneficiary = () => {
    setViewBeneficiary(false);
    setAllocatedClient(emptyClient);
  };

  const toggleFalse = (evt, client) => {
    let toggle = document.getElementById(evt.target.id);
    if (
      toggle?.checked == true ||
      evt.target.id == "beneficiary-view" ||
      evt.target.id == "edit-client" ||
      evt.target.id == "delete-client"
    ) {
      return client;
    } else {
      return emptyClient;
    }
  };

  const allocateClient = (evt, client) => {
    setAllocatedClient(toggleFalse(evt, client));
  };

  const confirmClient = async () => {
    setShowLoader(true);
    setViewClient(false);
    try {
      await createClient(allocatedClient);
      setSuccess(true);
      setShowLoader(false);
      setShowConfirmation(true);
      setRequestMessage("Client Successfully Created");
    } catch (ex) {
      setSuccess(false);
      setShowLoader(false);
      setShowConfirmation(true);
      setRequestMessage(`${ex.message}. Please contact system admin.`);
    } finally {
      doClientSearch();
    }
  };

  const showNotes = (c) => {
    setAllocatedClient(c ? c : emptyClient);
    setShowNote((prev) => !prev);
  };

  const confirmEntityBeneficiary = async (benficiary) => {
    setShowLoader(true);
    try {
      // await createEntityBeneficiary(benficiary);
      await createBeneficiary(benficiary);
      setSuccess(true);
      setShowLoader(false);
      setAddBeneficiary(false);
      setShowConfirmation(true);
      setRequestMessage("Entity Beneficiary Successfully Created");
    } catch (ex) {
      setSuccess(false);
      setShowLoader(false);
      setAddBeneficiary(false);
      setShowConfirmation(true);
      setRequestMessage(`${ex.message}. Please contact system admin.`);
    } finally {
      doClientSearch();
    }
  };

  const handleUpdateEntityBeneficiary = async (beneficiary) => {
    setShowLoader(true);
    try {
      // await updateEntityBeneficiaryApi(beneficiary.id, beneficiary);
      await updateBeneficiary(beneficiary);
      setSuccess(true);
      setShowLoader(false);
      setEditBeneficiary(false);
      setViewBeneficiary(false);
      setShowConfirmation(true);
      setRequestMessage("Entity Beneficiary Successfully Updated");
    } catch (ex) {
      setSuccess(false);
      setShowLoader(false);
      setEditBeneficiary(false);
      setViewBeneficiary(false);
      setShowConfirmation(true);
      setRequestMessage(`${ex.message}. Please contact system admin.`);
    } finally {
      doClientSearch();
    }
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    if (name === "searchText") setSearchText(value);
    else if (name === "searchFilter") setSearchFilter(value);
    else if (name === "rows_per_page") setRowsPerPage(value);
  };

  const resetPage = () => {
    setPage(1);
  };

  const pageUp = () => {
    setPage((prev) => (prev !== pageCount ? prev + 1 : prev));
  };

  const pageDown = () => {
    setPage((prev) => (prev !== 1 ? prev - 1 : prev));
  };

  const handlers = {
    PREVIEW: () => doClientSearch(),
  };

  return (
    <>
      <HotKeys className="w-100" keyMap={keyMap} handlers={handlers}>
        <div className="trade-table">
          <Search
            options={searchOptions}
            searchCallback={doClientSearch}
            searchFilter={searchFilter}
            searchText={searchText}
            resetPage={resetPage}
            handleChange={handleChange}
          />
          <Table hover className="modern-table">
            <thead>
              <tr>
                {/* <th style={{ width: "20px" }}> </th> */}
                <th style={{ width: "100px" }}>
                  <TableHeaderSort
                    header="Customer"
                    sortParam="firstname"
                    sortData={clientSort}
                    sortArray={sortArray}
                  />
                </th>
                <th style={{ width: "100px" }}>
                  <TableHeaderSort
                    header="Balance"
                    sortParam="balance"
                    sortData={clientSort}
                    sortArray={sortArray}
                  />
                </th>
                <th style={{ width: "150px" }}>
                  <TableHeaderSort
                    header="Allowance SDA Usage"
                    sortParam="allowance_sda"
                    sortData={clientSort}
                    sortArray={sortArray}
                  />
                </th>
                <th style={{ width: "150px" }}>
                  <TableHeaderSort
                    header="Allowance FIA Usage"
                    sortParam="allowance_fia"
                    sortData={clientSort}
                    sortArray={sortArray}
                  />
                </th>
                <th style={{ width: "80px" }}>
                  <TableHeaderSort
                    header="Beneficiaries"
                    sortParam="benficiary_count"
                    sortData={clientSort}
                    sortArray={sortArray}
                  />
                </th>
                {/* <th style={{ width: "60px" }}></th> */}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={40}>
                    <Loader />
                  </td>
                </tr>
              ) : data.length > 0 ? (
                data.map((d) => {
                  {/* console.log('Client record: ', d); */}
                  return (
                    <tr className="clickable-row" key={d.id}>
                      {/* <td>
                        <Form.Check
                          id={`toggleClientRadio-${d.id}`}
                          name="toggleClientRadio"
                          type="radio"
                          onChange={(evt) => {
                            allocateClient(evt, d);
                          }}
                        />
                      </td> */}
                      <td>
                        <div
                          className="flex-row"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            showViewClient(d, "view");
                          }}
                        >
                          <span>{`${d.firstname} ${d.surname}`}</span>
                        </div>
                      </td>
                      <td
                        style={{ textAlign: "right", cursor: "pointer" }}
                        onClick={() => {
                          showViewClient(d, "view");
                        }}
                      >
                        <div className="row">
                          <div className="col-12">
                            {numberFormat(d.balance ? d.balance : "0.00")}
                          </div>
                        </div>
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          showViewClient(d, "view");
                        }}
                      >
                        <div className="allowance-wrapper row">
                          <div className="col-3 pr-0">
                            <span className="allowance sda">SDA</span>
                          </div>
                          <div className="col-9 pr-0 pl-1">
                            <span className="allowace-figure">
                              {numberFormat(
                                d.sda_allowance ? d.sda_allowance : "0.00",
                              )}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          showViewClient(d, "view");
                        }}
                      >
                        <div className="allowance-wrapper row">
                          <div className="col-3 pr-0">
                            <span className="allowance fia">FIA</span>
                          </div>
                          <div className="col-9 pr-0 pl-1">
                            <span className="allowace-figure">
                              {numberFormat(
                                d.fia_allowance ? d.fia_allowance : "0.00",
                              )}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td
                        id="beneficiary-view"
                        name="beneficiary-view"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          showViewBeneficiary(d);
                        }}
                      >
                        <AIIcons.AiOutlineTeam id="beneficiary-view" />{" "}
                        <span className="notes-count" id="beneficiary-view">
                          {d.beneficiary_count}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={40}> No records found </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="row mt-2 table-footer">
            {/* <div className="col-8 card flex-row">
              <span>Hot Keys:</span>
              <span>Shift + R (Refresh)</span>
            </div> */}
            <div className="col-4 flex-row card bg-w">
              <Pagination
                handleChange={handleChange}
                search={doClientSearch}
                rows_per_page={rowsPerPage}
                resetPage={resetPage}
                page={page}
                page_count={pageCount}
                pageUp={pageUp}
                pageDown={pageDown}
                upper_threshold={upperThreshold}
                lower_threshold={lowerThreshold}
              />
            </div>
          </div>
        </div>
      </HotKeys>
      {showNote ? (
        <NoteModal
          showNotes={showNote}
          showModal={showNotes}
          trade_id={null}
          client_id={allocatedClient.entity}
          client={`${allocatedClient.firstname} ${allocatedClient.surname}`}
          tradeSearch={doClientSearch}
        />
      ) : (
        <></>
      )}

      {addClient ? (
        <ClientForm
          showForm={showAddClient}
          client={allocatedClient}
          isShown={addClient}
          next={showViewClient}
          close={closeAddClient}
        />
      ) : null}

      {viewClient ? (
        <ClientView
          isShown={viewClient}
          close={closeViewClient}
          back={showAddClient}
          client={allocatedClient}
          next={confirmClient}
          type={clientFormType}
        />
      ) : null}

      {viewBeneficiary ? (
        <EntityBeneficiaryView
          isShown={viewBeneficiary}
          close={closeViewBeneficiary}
          client={allocatedClient}
          addNew={() => {
            setViewBeneficiary(false);
            showAddBeneficiary();
          }}
          edit={showEditBeneficiary}
        />
      ) : null}

      {addBeneficiary ? (
        <EntityBeneficiaryForm
          isShown={addBeneficiary}
          close={closeAddBeneficiary}
          back={backFromAddBeneficiary}
          client={allocatedClient}
          next={confirmEntityBeneficiary}
          type="create"
          countries={countries}
          currencies={currencies}
        />
      ) : null}

      {editBeneficiary ? (
        <EntityBeneficiaryEditForm
          isShown={editBeneficiary}
          close={closeEditBeneficiary}
          back={backFromEditBeneficiary}
          client={allocatedClient}
          next={handleUpdateEntityBeneficiary}
          type="update"
          beneficiary={allocatedBeneficiary}
          countries={countries}
          currencies={currencies}
        />
      ) : null}

      <FormLoader
        isShown={showLoader}
        message="Saving Information"
        close={() => {
          setShowLoader(false);
        }}
      />

      <RequestResponseModal
        isShown={showConfirmation}
        message={requestMessage}
        success={success}
        close={() => {
          setShowConfirmation(false);
        }}
      />

      {/* <BeneficiaryForm
        isShown={addBeneficiary}
        close={closeAddBeneficiary}
        allocatedClient={allocatedClient}
      />

      <CurrentTrades
        isShown={currentTradeModal}
        close={closeCurrentTrade}
      />
      <CurrentTradesReport
        isShown={currentTradeReportModal}
        close={closeCurrentTradeReport}
      />

      <CurrentMarketOrders
        isShown={currentMarkertOrdersModal}
        close={closeCurrentMarketOrders}
      /> */}
    </>
  );
};

ClientTable.propTypes = {
  data: PropTypes.array,
};

export default ClientTable;
